import React, { useEffect, useState } from "react";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { getApi } from "../../pages/AppApis";

export default function VerifyAccountPopup() {
    const navigate = useNavigate();
    const [verificationData, setVerificationData] = useState([]);

    return (
        <div
            onClick={(e) => e.stopPropagation()}
            className="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-flex tw-items-center tw-justify-center tw-z-50"
        >
            <div className="tw-bg-white tw-shadow-lg tw-rounded-lg tw-p-6 tw-items-center tw-flex tw-flex-col tw-w-[90%] md:tw-w-[500px]">
                <p className="tw-text-[22px] tw-text-black">Your Property is Saved!</p>
                <hr className="tw-mt-2 tw-mb-10 tw-w-full tw-bg-[#D0D5DD]" />
                <RiVerifiedBadgeFill size={40} color="#1ABC9C" />

                <p className="tw-text-center tw-text-black tw-text-[23px] tw-font-[700] tw-my-5">
                    Your listing has been saved but is not yet published.
                </p>
                <p className="tw-text-center tw-text-black tw-text-[17px]">To make it live, please verify your account.</p>

                <button
                    onClick={() => navigate("/start-verification")}
                    className="tw-bg-primary tw-mt-6 tw-text-white tw-rounded-md tw-h-[60px] tw-flex tw-items-center tw-justify-center tw-w-[260px]"
                >
                    Verify Account
                </button>
                <div onClick={() => navigate("/MyProperties")} className="tw-text-black tw-underline tw-mt-5 tw-cursor-pointer">
                    Go to My Properties
                </div>
            </div>
        </div>
    );
}
